<app-dialog-wrapper>
  <div class="content">
    <form [formGroup]="dateTimeForm" class="content__form">
      <div class="content__form-date">
        <app-date-picker
          formControlName="date"
          placeholder="Select date"
          [minDate]="currentDate"
          [disabled]="availableDates().length === 0"
          [availableDates]="availableDates()"
          (select)="onDateSelect($event)"
        />
      </div>

      @if (showTimePicker()) {
        <div class="content__form-time">
          @if (isSlotMode()) {
            <app-dropdown
              formControlName="time"
              placeholder="Select time"
              [label]="timeLabel()"
              [options]="timeOptions()"
              [optionValueName]="'id'"
              [optionLabelName]="'label'"
              [size]="DropdownSize.Big"
              [style]="DropdownStyle.Secondary"
            />
          } @else {
            <app-time-picker formControlName="time" [label]="timeLabel()" />
          }
        </div>
      }

      <div class="content__form-asap">
        <app-checkbox
          label="As Soon As Possible"
          formControlName="is_asap"
          (valueChange)="onIsAsapChange($event)"
        />
      </div>
    </form>
  </div>

  <div footer class="footer">
    <app-button
      [outline]="true"
      [size]="ButtonSize.Large"
      [style]="ButtonStyle.Danger"
      (buttonClick)="closeDialog()"
    >
      Cancel
    </app-button>

    <app-button [size]="ButtonSize.Large" (buttonClick)="onSubmit()">
      Confirm
    </app-button>
  </div>
</app-dialog-wrapper>
